const legal = {
  legal: {
    privacy: {
      title: "Politique de confidentialité",
      lastUpdatedLabel: "Dernière mise à jour",
      intro:
        "Cette politique explique comment les données personnelles sont collectées et traitées lorsque vous utilisez ce site (portfolio professionnel, blog, formulaire de contact et inscription à une newsletter).",
      controller: {
        title: "Responsable du traitement",
        items: [
          "Responsable : Alexandre SANOU (portfolio professionnel)",
          "Contact : via le formulaire de contact du site ou LinkedIn",
          "Zone : Île-de-France / Remote",
        ],
      },
      processing: {
        title: "Données traitées",
        sections: [
          {
            title: "Formulaire de contact",
            items: ["Nom", "Email", "Téléphone", "Sujet", "Message", "Métadonnées techniques (date d’envoi)"],
          },
          {
            title: "Newsletter (blog)",
            items: ["Nom", "Email", "Métadonnées techniques (date d’inscription)"],
          },
          {
            title: "Données techniques",
            items: [
              "Préférences stockées localement (langue)",
              "Données de session d’administration (authentification) stockées localement par le client d’auth",
              "Journaux techniques et mesures d’audience (si activées) : pages vues, évènements, informations techniques (navigateur, appareil)",
            ],
          },
        ],
      },
      purposes: {
        title: "Finalités et bases légales",
        items: [
          "Répondre à vos demandes (contact) : intérêt légitime et/ou mesures précontractuelles.",
          "Envoyer une newsletter (si vous vous inscrivez) : consentement (retrait possible à tout moment).",
          "Améliorer le site et mesurer l’audience (si activé) : consentement lorsque requis par la réglementation.",
          "Sécuriser le site et prévenir la fraude/abus : intérêt légitime.",
        ],
      },
      recipients: {
        title: "Destinataires et sous-traitants",
        intro:
          "Les données peuvent être traitées par des prestataires strictement nécessaires au fonctionnement du site :",
        items: [
          "Supabase (base de données, authentification, stockage) : hébergement et traitement des données liées au formulaire et à l’administration.",
          "EmailJS (envoi d’emails) : transmission des informations de contact pour l’acheminement du message.",
          "Calendly (prise de rendez-vous via liens) : traitement des données que vous fournissez directement à Calendly.",
          "Hébergeur/CDN du site (selon déploiement) : journaux techniques et diffusion du contenu.",
          "Google Analytics 4 / outils de mesure d’audience (si activés) : statistiques de navigation.",
        ],
      },
      retention: {
        title: "Durées de conservation",
        items: [
          "Messages via formulaire de contact : jusqu’à 24 mois après le dernier échange, puis suppression/archivage.",
          "Newsletter : jusqu’à désinscription, puis au maximum 3 ans après le dernier contact actif.",
          "Journaux techniques : durée limitée, en général jusqu’à 12 mois (selon l’hébergeur).",
        ],
      },
      transfers: {
        title: "Transferts hors UE/EEE",
        text:
          "Certains prestataires peuvent traiter des données en dehors de l’UE/EEE. Dans ce cas, des garanties appropriées sont mises en place lorsque disponibles (ex. clauses contractuelles types, mesures techniques).",
      },
      security: {
        title: "Sécurité",
        text:
          "Des mesures techniques et organisationnelles raisonnables sont mises en œuvre pour protéger vos données. Aucun système n’étant infaillible, la sécurité absolue ne peut être garantie.",
      },
      rights: {
        title: "Vos droits (RGPD)",
        intro:
          "Vous disposez des droits suivants, selon les conditions prévues par le RGPD :",
        items: [
          "Accès, rectification, effacement",
          "Limitation et opposition",
          "Portabilité",
          "Retrait du consentement (newsletter, audience) à tout moment",
          "Réclamation auprès d’une autorité de contrôle (CNIL en France)",
        ],
        contact:
          "Pour exercer vos droits : utilisez le formulaire de contact en précisant l’objet de votre demande.",
      },
      aiAct: {
        title: "Transparence (AI Act)",
        text:
          "Ce site ne fournit pas un système d’IA interactif destiné à produire des décisions à votre sujet. Les données envoyées via le formulaire/inscription ne sont pas utilisées pour entraîner des modèles d’IA. Si des outils d’assistance (y compris IA) sont utilisés pour rédiger des contenus ou réponses, cela se fait sous contrôle humain et sans prise de décision automatisée à votre égard.",
      },
      changes: {
        title: "Modifications",
        text:
          "Cette politique peut évoluer. La date de mise à jour affichée en haut de page indique la dernière version.",
      },
      disclaimer:
        "Information : ce document est fourni à titre informatif et ne constitue pas un avis juridique.",
    },
    terms: {
      title: "Conditions d’utilisation",
      lastUpdatedLabel: "Dernière mise à jour",
      intro:
        "Ces conditions encadrent l’utilisation de ce site (portfolio, blog, formulaires et contenus). En naviguant sur le site, vous acceptez ces conditions.",
      scope: {
        title: "Objet",
        items: [
          "Présenter des informations professionnelles (portfolio, services, cas clients).",
          "Publier des contenus (blog) et permettre l’inscription à une newsletter.",
          "Permettre la prise de contact via formulaire et liens externes (ex. Calendly).",
        ],
      },
      access: {
        title: "Accès au site",
        text:
          "Le site est accessible en l’état, sous réserve d’interruptions (maintenance, incident, contraintes techniques). Aucune garantie de disponibilité continue n’est donnée.",
      },
      conduct: {
        title: "Usage acceptable",
        items: [
          "Ne pas tenter d’accéder sans autorisation à l’administration, au code ou aux données.",
          "Ne pas perturber le fonctionnement du site (scraping abusif, attaques, spam).",
          "Ne pas utiliser le formulaire pour envoyer des contenus illicites.",
        ],
      },
      ip: {
        title: "Propriété intellectuelle",
        text:
          "Sauf mention contraire, les contenus (textes, visuels, branding) sont protégés. Toute reproduction/utilisation au-delà de la consultation personnelle nécessite une autorisation.",
      },
      userContent: {
        title: "Messages et contributions",
        text:
          "Les informations que vous transmettez via le formulaire (ou tout canal indiqué) doivent être exactes et ne pas porter atteinte aux droits de tiers. Vous restez responsable de vos messages.",
      },
      newsletter: {
        title: "Newsletter",
        items: [
          "L’inscription est volontaire et fondée sur votre consentement.",
          "Vous pouvez vous désinscrire à tout moment via le lien de désinscription (s’il est présent) ou via le formulaire de contact.",
        ],
      },
      external: {
        title: "Liens externes",
        text:
          "Le site peut contenir des liens vers des services tiers (LinkedIn, GitHub, Calendly). Leur contenu et leurs politiques relèvent de leur responsabilité.",
      },
      liability: {
        title: "Responsabilité",
        text:
          "Les informations du site sont fournies à titre indicatif. Malgré le soin apporté, des erreurs peuvent survenir. La responsabilité ne saurait être engagée pour des dommages indirects liés à l’utilisation du site.",
      },
      law: {
        title: "Droit applicable",
        text:
          "Ces conditions sont régies par le droit français. En cas de litige, les parties rechercheront une solution amiable avant toute action.",
      },
      changes: {
        title: "Modification des conditions",
        text:
          "Les conditions peuvent être modifiées. La date de mise à jour affichée en haut de page indique la dernière version.",
      },
      disclaimer:
        "Information : ce document est fourni à titre informatif et ne constitue pas un avis juridique.",
    },
  },
};

export default legal;
